import type { IconProps } from './IconProps';

export const LightningIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.46587 0.645562C9.77128 0.778139 9.95273 1.09619 9.91143 1.42656L9.35015 5.91687H13.3619C13.3703 5.91687 13.3789 5.91687 13.3874 5.91687C13.5464 5.91683 13.7127 5.91679 13.8496 5.92918C13.9783 5.94083 14.2406 5.9724 14.4698 6.1576C14.7288 6.36687 14.8771 6.68361 14.8721 7.01654C14.8676 7.31117 14.724 7.5329 14.6505 7.63921C14.5724 7.75229 14.4659 7.88001 14.3641 8.00219L8.41006 15.147C8.19691 15.4028 7.84066 15.4874 7.53525 15.3548C7.22984 15.2223 7.04839 14.9042 7.08968 14.5738L7.65097 10.0835H3.63925C3.63077 10.0835 3.62227 10.0835 3.61375 10.0835C3.45468 10.0836 3.28839 10.0836 3.15152 10.0712C3.02285 10.0596 2.76052 10.028 2.53133 9.84281C2.27236 9.63353 2.12401 9.31679 2.12903 8.98387C2.13347 8.68924 2.27716 8.46751 2.35059 8.3612C2.42869 8.24812 2.53517 8.1204 2.63703 7.99822C2.64249 7.99168 2.64794 7.98515 2.65336 7.97863L8.59106 0.8534C8.80421 0.597624 9.16046 0.512985 9.46587 0.645562ZM4.10184 8.58354H8.50056C8.71568 8.58354 8.92045 8.67591 9.06282 8.83719C9.20519 8.99846 9.27145 9.2131 9.24477 9.42656L8.8954 12.2215L12.8993 7.41687H8.50056C8.28544 7.41687 8.08067 7.3245 7.9383 7.16322C7.79593 7.00195 7.72967 6.78731 7.75635 6.57384L8.10572 3.77888L4.10184 8.58354Z"
      fill="currentColor"
    />
  </svg>
);
